export interface RegulationFileReq {
  fileKey: string;
  fileName: string;
  fileSize: number;
  blobUrlForLargeFile?: string;
}

export interface RegulationFileRes {
  id: number;
  fileKey: string;
  fileName: string;
  fileSize: number;
  blobUrlForLargeFile?: string;
  createTime: string;
}

export interface RegulationRes {
  id: number;
  title: string;
  description: string;
  exposeSiteLanguage: string;
  category: string;
  writerId: string;
  lastModifierId: string;
  createTime: string;
  updateTime: string;
  files: RegulationFileRes[];
}

export interface RegulationListRes {
  id: number;
  title: string;
  description: string;
  exposeSiteLanguage: string;
  category: string;
  writerId: string;
  lastModifierId: string;
  createTime: string;
  updateTime: string;
  files: RegulationFileRes[];
}

export interface RegulationCreateReq {
  title: string;
  description: string;
  exposeSiteLanguage: string;
  category: string;
  files?: RegulationFileReq[];
}

export interface RegulationUpdateReq {
  title: string;
  description: string;
  exposeSiteLanguage: string;
  category: string;
  files?: RegulationFileReq[];
}

export const PPWR_CATEGORIES = ['INV', 'PLC', 'HMI', 'SERVO'] as const;
export type RegulationCategory = typeof PPWR_CATEGORIES[number];
